/*
 * Copyright (c) 2023. All rights reserved by kudiyar
 *
 */

import LoginForm from "./security/LoginForm";
import {useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {Button} from "@mui/material";
import CategoryTable from "./tables/CategoryTable";
import axios from "axios";
import ProductTable from "./tables/ProductTable";
import CreateCategoryDialog from "./dialogs/CreateCategoryDialog";

const AdminMain = () => {

    const [products, setProducts] = useState([])
    useEffect(() => {
        getProducts()
            .then((data) => {
                setProducts(data);
            })
            .catch((error) => {
                console.error("Error fetching products:", error);
            });
    }, []);
    const key = localStorage.getItem("H1LI")
    const navigate = useNavigate()
    const [selectedProduct, setSelectedProduct] = useState([])
    const [selectedcatid, setSelectedcatid] = useState(0)
    useEffect(() => {
        if (key != "LoOWorld") {
            navigate('/login')
        }
    })

return (

   <div style={{display:"flex"}}>
       <CategoryTable categories={products} ssp={setSelectedProduct} ssc={setSelectedcatid}/>
       <ProductTable products={selectedProduct} catid={selectedcatid} />
   </div>
)
}


async function getProducts() {
    try {
        const response = await axios.get("https://kudiyarapi.gigagile.space/products", {
                headers : {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Credentials": "*"
                }
            }
        );
        return response.data;
    } catch (error) {
        throw error;
    }
}
export default AdminMain